import { useState, useEffect, useCallback } from 'react';
import { useApi, identityApiRef, configApiRef } from '@backstage/core-plugin-api';
import { AppCardProps } from '../components/AppCard';

export const useHomepageProducts = (tabId: string = 'marketplace') => {
  const [products, setProducts] = useState<AppCardProps[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const identityApi = useApi(identityApiRef);
  const configApi = useApi(configApiRef);
  const baseUrl = configApi.getString('backend.baseUrl');

  const fetchProducts = useCallback(async () => {
    try {
      setLoading(true);
      const credentials = await identityApi.getCredentials();
      const response = await fetch(`${baseUrl}/api/custom-api/onboarding/assets/${tabId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${credentials.token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.statusText}`);
      }
      const data = await response.json();
      setProducts(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [baseUrl, identityApi, tabId]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, loading, error, refetch: fetchProducts };
};